import { Briefcase, TrendingUp, Gift, Settings, Plug, Target } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/hooks/useLanguage";

const iconMap = [Briefcase, Gift, TrendingUp, Settings, Plug, Target];
const colorMap = [
  { color: "text-accent", bgColor: "bg-accent/10" },
  { color: "text-primary", bgColor: "bg-primary/10" },
  { color: "text-orange-500", bgColor: "bg-orange-500/10" },
  { color: "text-violet-500", bgColor: "bg-violet-500/10" },
  { color: "text-accent", bgColor: "bg-accent/10" },
  { color: "text-primary", bgColor: "bg-primary/10" },
];

const PartnerBenefits = () => {
  const { t, tObject } = useLanguage();
  const benefits = tObject<Array<{ title: string; description: string }>>("partnerPage.benefits");

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">{t("partnerPage.benefitsTitle")}</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">{t("partnerPage.benefitsDescription")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[index] || Briefcase;
            const colors = colorMap[index] || colorMap[0];
            return (
              <Card key={index} className="border-border/50 hover:shadow-lg transition-all hover:-translate-y-1">
                <CardContent className="p-6">
                  <div className={`w-12 h-12 ${colors.bgColor} rounded-xl flex items-center justify-center mb-4`}>
                    <Icon className={`w-6 h-6 ${colors.color}`} />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-2">{benefit.title}</h3>
                  <p className="text-muted-foreground text-sm">{benefit.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartnerBenefits;
